export default function ServerDirective() {
  return {
    template: require('./server.html'),
    scope: {
      assessmentId: '=',
      customerId: '=',
      server: '=',
      deleteCallback: '&',
      tooltipAppendToSelector: '@',
    },
    controller: 'ServerController',
    controllerAs: 'serverVM',
    bindToController: true,
    replace: true,
  };
}
